/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OrgSessionSummary
 */
export interface OrgSessionSummary {
    /**
     * The device group tag for this organisation
     * @type {string}
     * @memberof OrgSessionSummary
     */
    deviceGroupTag?: string;
    /**
     * The organisation name
     * @type {string}
     * @memberof OrgSessionSummary
     */
    orgName?: string;
    /**
     * Number of chargers in this organisation
     * @type {number}
     * @memberof OrgSessionSummary
     */
    chargerCount?: number;
    /**
     * Total number of charging sessions
     * @type {number}
     * @memberof OrgSessionSummary
     */
    sessionCount?: number;
    /**
     * Total energy delivered in Wh
     * @type {number}
     * @memberof OrgSessionSummary
     */
    energyWh?: number;
    /**
     * Charging success rate as a percentage (0-100)
     * @type {number}
     * @memberof OrgSessionSummary
     */
    chargingSuccessRate?: number;
}

/**
 * Check if a given object implements the OrgSessionSummary interface.
 */
export function instanceOfOrgSessionSummary(
    value: object,
): value is OrgSessionSummary {
    return true;
}

export function OrgSessionSummaryFromJSON(json: any): OrgSessionSummary {
    return OrgSessionSummaryFromJSONTyped(json, false);
}

export function OrgSessionSummaryFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): OrgSessionSummary {
    if (json == null) {
        return json;
    }
    return {
        deviceGroupTag:
            json["deviceGroupTag"] == null ? undefined : json["deviceGroupTag"],
        orgName: json["orgName"] == null ? undefined : json["orgName"],
        chargerCount:
            json["chargerCount"] == null ? undefined : json["chargerCount"],
        sessionCount:
            json["sessionCount"] == null ? undefined : json["sessionCount"],
        energyWh: json["energyWh"] == null ? undefined : json["energyWh"],
        chargingSuccessRate:
            json["chargingSuccessRate"] == null
                ? undefined
                : json["chargingSuccessRate"],
    };
}

export function OrgSessionSummaryToJSON(value?: OrgSessionSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        deviceGroupTag: value["deviceGroupTag"],
        orgName: value["orgName"],
        chargerCount: value["chargerCount"],
        sessionCount: value["sessionCount"],
        energyWh: value["energyWh"],
        chargingSuccessRate: value["chargingSuccessRate"],
    };
}
